module.exports = __webpack_public_path__ + "static/media/25488369_1703512259723958_6018751344357213526_o.08f77fab.jpg";